import EntityModel from '@/Modules/Entity/EntityModel.js'
import axios from 'axios'
import SelectOptionModel from '@/Modules/Dataset/SelectOptionModel.js'

export default class EntityService {
  static list = ({ parameters, filters }) =>
    axios.get(`/entities${filters}`, {
      params: parameters,
      excludeLoader: true,
    })

  static listParent = () =>
    axios.get(`/entities/list/parent`, {
      excludeLoader: true,
    })

  static changeStatus = (entityId, payload) =>
    axios.post(`/entities/${entityId}/change-status`, payload)

  static create = (payload) => axios.post(`/entities`, payload)
  static update = (entityId, payload) =>
    axios
      .put(`/entities/${entityId}`, payload)
      .then((response) => new EntityModel(response.data.data))
  static delete = (entityId) => axios.delete(`/entities/${entityId}`)
  static show = (entityId) =>
    axios
      .get(`entities/${entityId}`)
      .then((response) => new EntityModel(response.data.data))
  static generateCode = () => axios.get('entities/code')
  static updateData = (entityId, data) =>
    axios.put(`entities/${entityId}/update-data`, data)

  static uploadLogo = (entityId, data) =>
    axios.post(`entities/${entityId}/logo`, data)

  static getLogo = (entityId) => axios.get(`entities/${entityId}/logo`)

  static brokerContacts = (entityId) =>
    axios
      .get(`/entities/${entityId}/contacts`)
      .then((response) =>
        _.map(response.data.data, (item) => new SelectOptionModel(item))
      )
}
